var _require = require('./simplify_entity'),
    simplifyEntity = _require.simplifyEntity;

module.exports = {
  wd: {
    entities: function entities(res) {
      res = res.body || res;
      var _res = res,
          entities = _res.entities;
      Object.keys(entities).forEach(function (entityId) {
        entities[entityId] = simplifyEntity(entities[entityId]);
      });
      return entities;
    }
  }
};